var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import css from '@styled-system/css';
import React from 'react';
import styled from 'styled-components';
import { border, color, compose, layout, space, } from 'styled-system';
import theme from '../theme';
const StyledTab = styled.div `
  ${css({
    borderBottomColor: 'gray.4',
    borderBottomStyle: 'solid',
    borderBottomWidth: '2',
    color: 'gray.4',
    cursor: 'pointer',
    flex: '1 1 0',
    fontFamily: 'body',
    fontSize: '0',
    fontWeight: 'bold',
    padding: '3',
    textAlign: 'center',
})}
  &.active {
    ${({ tabColor }) => {
    const color = tabColor || 'brand';
    return css({
        borderBottomColor: color,
        color,
    });
}}
  }
  &:hover {
    ${css({
    backgroundColor: 'gray.6',
})}
  }
  ${compose(space, color, layout, border)}
`;
function Tab(_a) {
    var { active, index, onClick, title, tabColor, theme } = _a, rest = __rest(_a, ["active", "index", "onClick", "title", "tabColor", "theme"]);
    const className = active ? 'active' : '';
    return (React.createElement(StyledTab, Object.assign({ onClick: () => onClick && onClick(index), className: className, tabColor: tabColor, theme: theme }, rest), title));
}
Tab.defaultProps = { theme };
export default Tab;
//# sourceMappingURL=Tab.js.map